<template>
    <form-dialog :value="value" @input="$emit('input', $event)" max-width="600">
        <template #activator="bindings">
            <slot v-bind="bindings"></slot>
        </template>
        <template #default="{ open }">
            <update-entity-spend-limit-card
                :value="tagkeyvalue"
                :loading="$wait.is('updateTagKeyValueSpendLimit')"
                #default="{ isValid, formId, loading, form }"
            >
                <back-button @click="open()"></back-button>
                <v-spacer></v-spacer>
                <patch-tag-key-value-button
                    :value="tagkeyvalue"
                    :patches="[{ op: 'replace', path: 'monthlySpendLimit', value: form.monthlySpendLimit }]"
                    :form="formId"
                    :clear="() => {}"
                    :valid="isValid"
                    :loading="loading"
                    v-wait-while="'updateTagKeyValueSpendLimit'"
                    @http2xx="handleSuccessfulSpendLimit"
                ></patch-tag-key-value-button>
            </update-entity-spend-limit-card>
        </template>
    </form-dialog>
</template>

<script>
import UpdateEntitySpendLimitCard from '@/components/Common/UpdateEntitySpendLimitCard.vue';
import PatchTagKeyValueButton from '@/components/Domain.Tags/PatchTagKeyValueButton.vue';
import { toastSuccess } from '@/components/Common/Toast.vue';
export default {
    props: {
        value: Boolean,
        tagkeyvalue: Object,
    },
    components: { UpdateEntitySpendLimitCard, PatchTagKeyValueButton },
    methods: {
        handleSuccessfulSpendLimit(response) {
            toastSuccess(`Successfully updated spend limit to ${response.monthlySpendLimit}`);
            this.$emit('input', false);
            this.$emit('http2xx', { ...this.tagkeyvalue, monthlySpendLimit: Number(response.monthlySpendLimit) });
        },
    },
};
</script>